export default "__VITE_ASSET__CHH0o4F7__"